module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"regularNotice":"contract relation terms"},"et":{"regularNotice":"contract relation terms"},"ru":{"regularNotice":"contract relation terms"}}')
  delete Component.options._Ctor
}
